export default __webpack_public_path__ + "static/media/faq-category-icon-5.2aac26c9.svg";